import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAuthTokenKey, getCollectionsKey, getNetworkKey, getSpaceKey, getSpacesKey, } from '../../utils/keys';
const spaceUpdater = (old) => ({
    ...old,
    authMemberProps: {
        ...old === null || old === void 0 ? void 0 : old.authMemberProps,
        lastReadAt: new Date().toISOString(),
        unreadPostsCount: 0,
    },
});
export const useReadSpace = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const collectionsKey = getCollectionsKey();
    const authTokenKey = getAuthTokenKey();
    const networkKey = getNetworkKey();
    return useMutation(input => client.spaces.read(input), {
        ...useMutationOptions,
        onMutate: variables => {
            var _a;
            const { spaceId } = variables;
            const spaceKey = getSpaceKey({ variables: { id: spaceId } });
            const spacesKey = getSpacesKey();
            const queries = queryClient.getQueriesData(spaceKey);
            queries.forEach(([key, space]) => {
                if (space) {
                    queryClient.setQueriesData(key, spaceUpdater(space));
                }
            });
            queryClient.setQueriesData(spacesKey, old => {
                var _a;
                return ({
                    ...old,
                    pages: (_a = old === null || old === void 0 ? void 0 : old.pages) === null || _a === void 0 ? void 0 : _a.map(page => {
                        var _a, _b;
                        return ({
                            ...page,
                            nodes: (_a = page === null || page === void 0 ? void 0 : page.nodes) === null || _a === void 0 ? void 0 : _a.map(space => (space === null || space === void 0 ? void 0 : space.id) === spaceId ? spaceUpdater(space) : space),
                            edges: (_b = page === null || page === void 0 ? void 0 : page.edges) === null || _b === void 0 ? void 0 : _b.map(edge => {
                                var _a;
                                return ({
                                    ...edge,
                                    node: ((_a = edge === null || edge === void 0 ? void 0 : edge.node) === null || _a === void 0 ? void 0 : _a.id) === spaceId
                                        ? spaceUpdater(edge === null || edge === void 0 ? void 0 : edge.node)
                                        : edge === null || edge === void 0 ? void 0 : edge.node,
                                });
                            }),
                        });
                    }),
                });
            });
            queryClient.setQueriesData(collectionsKey, old => old === null || old === void 0 ? void 0 : old.map(collection => {
                var _a, _b, _c, _d;
                return ({
                    ...collection,
                    spaces: {
                        ...collection === null || collection === void 0 ? void 0 : collection.spaces,
                        nodes: (_b = (_a = collection === null || collection === void 0 ? void 0 : collection.spaces) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.map(space => (space === null || space === void 0 ? void 0 : space.id) === spaceId ? spaceUpdater(space) : space),
                        edges: (_d = (_c = collection === null || collection === void 0 ? void 0 : collection.spaces) === null || _c === void 0 ? void 0 : _c.edges) === null || _d === void 0 ? void 0 : _d.map(edge => {
                            var _a;
                            return ({
                                ...edge,
                                node: ((_a = edge === null || edge === void 0 ? void 0 : edge.node) === null || _a === void 0 ? void 0 : _a.id) === spaceId
                                    ? spaceUpdater(edge === null || edge === void 0 ? void 0 : edge.node)
                                    : edge === null || edge === void 0 ? void 0 : edge.node,
                            });
                        }),
                    },
                });
            }));
            (_a = useMutationOptions === null || useMutationOptions === void 0 ? void 0 : useMutationOptions.onMutate) === null || _a === void 0 ? void 0 : _a.call(useMutationOptions, variables);
        },
        onSettled: (data, error, variables) => {
            const spaceKey = getSpaceKey({ variables: { id: variables === null || variables === void 0 ? void 0 : variables.spaceId } });
            queryClient.invalidateQueries(spaceKey);
            // Invalidate network and auth token queries since their unread posts count has changed
            queryClient.invalidateQueries(networkKey);
            queryClient.invalidateQueries(authTokenKey);
        },
    });
};
//# sourceMappingURL=useReadSpace.js.map